import multicareConfig from "./multicare"
import eleganzaConfig from "./eleganza4"
import sprintConfig from "./sprint"
import aveConfig from "./ave2"
import gracieConfig from "./gracie"
import essenzaConfig from "./essenza300"
import essenzaLtConfig from "./essenza300lt"
import essenza200Config from "./essenza200"

export default [
  {
    name: 'multicare',
    title: 'Multicare X',
    image: 'multicare.png',
    category: 'ICU',
    model: 'models/multicare/multicare.gltf',
    configuration: multicareConfig
  },
  {
    name: 'eleganza4',
    title: 'Eleganza 4',
    image: 'eleganza.png',
    category: 'ICU',
    model: 'models/eleganza4/eleganza.gltf',
    configuration: eleganzaConfig
  },
  {
    name: 'sprint',
    title: 'Sprint 200',
    image: 'sprint.png',
    category: 'ICU',
    model: 'models/sprint/sprint200_v010.gltf',
    configuration: sprintConfig
  },
  {
    name: 'ave2',
    title: 'Ave2',
    image: 'ave04.png',
    category: 'ICU',
    model: 'models/ave2/linetAve45.gltf',
    configuration: aveConfig
  },
  {
    name: 'gracie',
    title: 'Gracie',
    image: 'gracie.png',
    category: 'ICU',
    model: 'models/gracie/gracie48.gltf',
    configuration: gracieConfig
  },
  {
    name: 'essenza200',
    title: 'Essenza 200',
    image: 'essenza.png',
    category: 'ICU',
    model: 'models/essenza200/250122_E1.gltf',
    configuration: essenza200Config,
    default: true
  },
  {
    name: 'essenza300',
    title: 'Essenza 300',
    image: 'essenza.png',
    category: 'ICU',
    model: 'models/essenza300/essenza_cistka_240313.gltf',
    configuration: essenzaConfig
  },
  {
    name: 'essenza300lt',
    title: 'Essenza 300LT',
    image: 'essenza.png',
    category: 'ICU',
    model: 'models/essenza300lt/essenza_LT_alu_postranice_240312_jeden_model.gltf',
    configuration: essenzaLtConfig
  }
]